import { Directive, HostBinding, Input } from '@angular/core';
import { NgControl } from '@angular/forms';
import { LeadInjector } from 'src/app/core/models/lead/lead-injector.model';

@Directive({
    selector: '[appInjectorHtmlSnipped]',
    standalone: false
})
export class InjectorHtmlSnippedDirective {

  @Input() injector!: LeadInjector

  @Input() set encoding(type: 'multipart/form-data' | 'application/x-www-form-urlencoded' | undefined) {
    if (type) this.content = this.getContent(this.injector.injectionEndpoint, type)
  }

  @HostBinding('innerText') content = ''

  constructor(private ngControl: NgControl) { }

  ngOnInit(): void {
    this.ngControl.control?.setValue(this.getContent(this.injector.injectionEndpoint))
  }

  private getContent(url: string, encoding: 'multipart/form-data' | 'application/x-www-form-urlencoded' = 'application/x-www-form-urlencoded'): string {
    return `<form action="${url}" method="post" enctype="${encoding}">
    <input type="text" id="nome" name="nome" value="mario"/>
    <input type="text" name="cognome" value="rossi"/>
    <input type="text" id="tel" name="tel"/>
    <input type="text" name="mail" value="mario.rossi@example.com"/>
    <input type="text" id="hobby" name="hobby"/>
    <input type="text" id="piva" name="piva"/>
    <input type="text" id="indirizzo" name="indirizzo" value="via Manzoni"/>
    <input type="text" id="provincia" name="provincia" value="Mi"/>
    <input type="text" id="nota1" name="nota1"/>
    <input type="text" id="nota2" name="nota2"/>
    <input type="submit" value="Submit"/>
  </form>`
  }


}
